module.exports = __webpack_public_path__ + "img/honorListImg1.e5e22850.jpg";